var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 560,
    viewBox: "0 0 560 560",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196 187.5L280 31.5L360.5 194L542.5 221L417 350.5L440.5 524L388 506.5L339.5 482L282.5 448L122 524L146 350.5L22.5 221L196 187.5Z",
    fill: "#1B9A68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M374.555 499.629L423.626 525.428C434.796 531.3 447.849 521.816 445.718 509.379L418.293 349.489L534.46 236.254C543.496 227.446 538.509 212.101 526.022 210.287L365.485 186.959L293.689 41.487C288.105 30.171 271.969 30.171 266.385 41.487L194.589 186.959L34.0521 210.287C21.5648 212.101 16.5783 227.446 25.6138 236.254L141.781 349.489L114.357 509.379C112.223 521.816 125.278 531.3 136.448 525.428L280.038 449.938L340.596 481.777",
    stroke: "black",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGreen);
export default __webpack_public_path__ + "static/media/StarGreen.098f18b17de2e34fa4ce584d1f9a80c6.svg";
export { ForwardRef as ReactComponent };